import { playbackRates } from './playbackRates'

export const buttons = [[{
  title: ['HD'],
  identifier: 'HDClip',
  visibility: 'hidden',
}, {
  title: ['Hour'],
  identifier: 'hrClip',
  visibility: 'hidden',
}], [{
  icon: ['step backward'],
  identifier: 'stepBackward',
}, {
  icon: ['play', 'pause'],
  identifier: 'play',
}, {
  icon: ['step forward'],
  identifier: 'stepForward',
}], [{
  title: playbackRates.map(rate => `${rate}x`),
  identifier: 'speed',
  visibility: 'hidden',
}, {
  icon: ['history', 'unhide'],
  identifier: 'history',
  visibility: 'hidden',
}, {
  icon: ['window maximize'],
  identifier: 'fullscreen',
}]]

/*
  new ControlPanelButton({
    title: 'Hour',
    index: 'HrClip'
  }),
  new ControlPanelButton({
    icon: ['step backward'],
    index: 'stepBackward'
  }),
  new ControlPanelButton({
    icon: ['refresh'],
    index: 'refresh'
  }),
  new ControlPanelButton({
    icon: ['play', 'pause'],
    index: 'play'
  }),
  new ControlPanelButton({
    icon: ['step forward'],
    index: 'stepForward'
  }),
  new ControlPanelButton({
    title: '1x',
    index: 'speed'
  }),
  new ControlPanelButton({
    icon: ['history'],
    index: 'history'
  }),
  new ControlPanelButton({
    icon: ['window maximize'],
    index: 'fullscreen'
  })
]

export const buttonsByIndex = {
  'play': buttons[4]
}
*/
